import {inject} from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {CodebookService} from "@services";

function createCodebookResolver(config: keyof CodebookService): ResolveFn<Observable<any[]> | Promise<any[]> | any[]> {
  return (route: ActivatedRouteSnapshot,
          state: RouterStateSnapshot,
          codebookService: CodebookService = inject(CodebookService))
    : Observable<any[]> | Promise<any[]> | any[] => {
      return codebookService[config].value ?? [];
  };
}

export function generateCodebookResolvers(...configs: (keyof CodebookService)[]): any {
  const resolvers: { [key: string]: any } = {};

  for (const config of configs) {
    resolvers[config] = createCodebookResolver(config);
  }
  return resolvers;
}

export const raceCodebookResolver = generateCodebookResolvers(
  'sports',
  'waypointTypes',
  'registrationFeeTypes',
  'sizes',
  'transports',
  'meals',
  'currencies',
  'countries',
  'raceRegistrationTypes',
  'scoringForTypes',
  'timingEquipments',
  'timingSystems',
  'disciplines',
  'fieldConfigTypes',
  'genderSeparationTypes',
  'teamRankingTeamSeparationTypes',
  'visibilityTypes',
  'registrationDisplayFlags',
  'selectionOfTeamMembersTypes',
  'measurementTypes',
  'measurementPrecisionTypes',
  'applicationProcedureTypes',
  'typeOfApplicationTypes',
  'teamTypes',
  'raceStatuses',
  'languages',
  'startByTypeTypes',
  'resultDisplayTypes',
  'waypointMarkerTypes'
);

export const eventCodebookResolver = generateCodebookResolvers(
  'sports',
  'currencies',
  'countries',
  'eventTypes',
  'eventStatuses',
  'languages',
  'eventPaymentTypes',
  'eventPaymentMethods',
  'eventPaymentReminderMethods'
);

export const registerToRaceCodebookResolver = generateCodebookResolvers(
  'genders',
  'sizes',
  'transports',
  'currencies',
  'meals',
  'countries',
  'disciplines',
  'languages'
);

export const userProfileCodebookResolver = generateCodebookResolvers(
  'genders',
  'sizes',
  'meals',
  'languages',
  'countries'
);

export const organiserCodebookResolver = generateCodebookResolvers(
  'countries',
  'currencies',
  'categoryTypes',
  'languages'
);

export const eventCalendarCodebookResolver = generateCodebookResolvers(
  'countries', 'countriesForSearch', 'sports', 'sportsForSearch', 'languages')
